module.exports = __webpack_public_path__ + "static/media/cloud-check2.44e5c6db.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/cloud-check2.svg
// module id = 2634
// module chunks = 7